







































import Vue, { PropType } from 'vue'

import RoomDynamicCard from '@/components/in-room-registration/RoomDynamicCard.vue'
import StudentFilledAdminForm from '@/components/admin/StudentFilledAdminForm.vue'
import StudentAdminForm from '@/components/admin/StudentAdminForm.vue'
import { Actions } from '@/shared/Actions'
import { IRoom } from '@/models/IRoom'
import { IStudent } from '@/models/IStudent'

export default Vue.extend({
  components: {
    RoomDynamicCard,
    StudentFilledAdminForm,
    StudentAdminForm
  },
  props: {
    room: {
      type: Object as PropType<IRoom>,
      required: true
    }
  },
  data: () => ({
    studentToEdit: null,
    showStudentForm: false
  }),
  methods: {
    handleRemove(studentId: string) {
      this.$confirm(`Jesteś pewnien, że chcesz usunąć uczestnika?`, 'Potwierdzenie', {
        confirmButtonText: 'Tak',
        cancelButtonText: 'Nie',
        type: 'error'
      }).then(() => {
        this.$store.dispatch(Actions.ADMIN_STUDENT_REMOVE, {
          roomId: this.room._id,
          studentId
        })
      })
    },
    showEditForm(student: any) {
      this.studentToEdit = { ...student }
    },
    async handleAdd(student: IStudent) {
      await this.$store.dispatch(Actions.ADMIN_STUDENT_ADD, {
        roomId: this.room._id,
        student
      })
      this.showStudentForm = false
    },
    async handleEdit(student: IStudent) {
      await this.$store.dispatch(Actions.ADMIN_STUDENT_EDIT, {
        roomId: this.room._id,
        studentId: (student as any)._id,
        student
      })
      this.studentToEdit = null
    }
  }
})
